import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { createApp, type App } from 'vue';
import ElementPlus from 'element-plus';
import { i18n } from './i18n';
import PricingDialog from './PricingDialog.vue';

export interface PricingDialogService {
    open(): Promise<void>
}

@injectable()
export class PricingDialogServiceImpl implements PricingDialogService {
    private isPricingDialogOpen = false;

    open(): Promise<void> {
        if (this.isPricingDialogOpen) {
            return Promise.resolve();
        }

        this.isPricingDialogOpen = true;
        const div = document.createElement('div');
        div.setAttribute('data-theme', 'patsnapRD');
        div.classList.add('pricing-dialog-wrap');
        document.body.appendChild(div);

        const unmountApp = (app: App) => {
            app.unmount();
            document.body.removeChild(div);
        };

        const promise = new Promise<void>((resolve) => {
            const app = createApp(PricingDialog, {
                onClose: () => {
                    resolve();
                    unmountApp(app);
                    this.isPricingDialogOpen = false;
                },
            });
            app.use(ElementPlus);
            app.use(i18n);
            app.mount(div);
        });

        return promise;
    }
}

export const PricingDialogService = Symbol('PricingDialogService');
